module.exports = {
lines:[
    {
        chunks: {
            line_0_begin: {
                x: 45,
                y: 361
            },
            line_0_cell_0: {
                x: 67,
                y: 361
            },
            line_0_cell_1: {
                x: 249,
                y: 361
            },
            line_0_cell_2: {
                x: 431,
                y: 361
            },
            line_0_cell_3: {
                x: 613,
                y: 361
            },
            line_0_cell_4: {
                x: 795,
                y: 361
            },
            line_0_end: {
                x: 956,
                y: 361
            },
            line_0_gap_0: {
                x: 228,
                y: 361
            },
            line_0_gap_1: {
                x: 410,
                y: 361
            },
            line_0_gap_2: {
                x: 592,
                y: 361
            },
            line_0_gap_3: {
                x: 774,
                y: 361
            }
        },
        trajectory: [
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        chunks: {
            line_1_begin: {
                x: 45,
                y: 196
            },
            line_1_cell_0: {
                x: 67,
                y: 196
            },
            line_1_cell_1: {
                x: 249,
                y: 196
            },
            line_1_cell_2: {
                x: 431,
                y: 196
            },
            line_1_cell_3: {
                x: 613,
                y: 196
            },
            line_1_cell_4: {
                x: 795,
                y: 196
            },
            line_1_end: {
                x: 956,
                y: 196
            },
            line_1_gap_0: {
                x: 228,
                y: 196
            },
            line_1_gap_1: {
                x: 410,
                y: 196
            },
            line_1_gap_2: {
                x: 592,
                y: 196
            },
            line_1_gap_3: {
                x: 774,
                y: 196
            }
        },
        trajectory: [
            0,
            0,
            0,
            0,
            0
        ]
    },
    {
        chunks: {
            line_2_begin: {
                x: 45,
                y: 525
            },
            line_2_cell_0: {
                x: 67,
                y: 525
            },
            line_2_cell_1: {
                x: 249,
                y: 525
            },
            line_2_cell_2: {
                x: 431,
                y: 525
            },
            line_2_cell_3: {
                x: 613,
                y: 525
            },
            line_2_cell_4: {
                x: 795,
                y: 525
            },
            line_2_end: {
                x: 956,
                y: 525
            },
            line_2_gap_0: {
                x: 228,
                y: 525
            },
            line_2_gap_1: {
                x: 410,
                y: 525
            },
            line_2_gap_2: {
                x: 592,
                y: 525
            },
            line_2_gap_3: {
                x: 774,
                y: 525
            }
        },
        trajectory: [
            2,
            2,
            2,
            2,
            2
        ]
    },
    {
        chunks: {
            line_3_begin: {
                x: 45,
                y: 140
            },
            line_3_cell_0: {
                x: 67,
                y: 139
            },
            line_3_cell_1: {
                x: 249,
                y: 285
            },
            line_3_cell_2: {
                x: 431,
                y: 449
            },
            line_3_cell_3: {
                x: 613,
                y: 286
            },
            line_3_cell_4: {
                x: 795,
                y: 139
            },
            line_3_end: {
                x: 956,
                y: 139
            },
            line_3_gap_0: {
                x: 228,
                y: 265
            },
            line_3_gap_1: {
                x: 410,
                y: 429
            },
            line_3_gap_2: {
                x: 592,
                y: 431
            },
            line_3_gap_3: {
                x: 774,
                y: 267
            }
        },
        trajectory: [
            0,
            1,
            2,
            1,
            0
        ]
    },
    {
        chunks: {
            line_4_begin: {
                x: 45,
                y: 583
            },
            line_4_cell_0: {
                x: 67,
                y: 449
            },
            line_4_cell_1: {
                x: 249,
                y: 286
            },
            line_4_cell_2: {
                x: 431,
                y: 194
            },
            line_4_cell_3: {
                x: 613,
                y: 284
            },
            line_4_cell_4: {
                x: 795,
                y: 447
            },
            line_4_end: {
                x: 956,
                y: 583
            },
            line_4_gap_0: {
                x: 228,
                y: 431
            },
            line_4_gap_1: {
                x: 410,
                y: 268
            },
            line_4_gap_2: {
                x: 592,
                y: 264
            },
            line_4_gap_3: {
                x: 774,
                y: 429
            }
        },
        trajectory: [
            2,
            1,
            0,
            1,
            2
        ]
    },
    {
        chunks: {
            line_5_begin: {
                x: 45,
                y: 415
            },
            line_5_cell_0: {
                x: 67,
                y: 295
            },
            line_5_cell_1: {
                x: 249,
                y: 167
            },
            line_5_cell_2: {
                x: 431,
                y: 167
            },
            line_5_cell_3: {
                x: 613,
                y: 167
            },
            line_5_cell_4: {
                x: 795,
                y: 294
            },
            line_5_end: {
                x: 956,
                y: 415
            },
            line_5_gap_0: {
                x: 228,
                y: 268
            },
            line_5_gap_1: {
                x: 410,
                y: 167
            },
            line_5_gap_2: {
                x: 592,
                y: 167
            },
            line_5_gap_3: {
                x: 774,
                y: 267
            }
        },
        trajectory: [
            1,
            0,
            0,
            0,
            1
        ]
    },
    {
        chunks: {
            line_6_begin: {
                x: 45,
                y: 306
            },
            line_6_cell_0: {
                x: 67,
                y: 306
            },
            line_6_cell_1: {
                x: 249,
                y: 450
            },
            line_6_cell_2: {
                x: 431,
                y: 555
            },
            line_6_cell_3: {
                x: 613,
                y: 446
            },
            line_6_cell_4: {
                x: 795,
                y: 305
            },
            line_6_end: {
                x: 956,
                y: 306
            },
            line_6_gap_0: {
                x: 228,
                y: 421
            },
            line_6_gap_1: {
                x: 410,
                y: 555
            },
            line_6_gap_2: {
                x: 592,
                y: 555
            },
            line_6_gap_3: {
                x: 774,
                y: 417
            }
        },
        trajectory: [
            1,
            2,
            2,
            2,
            1
        ]
    },
    {
        chunks: {
            line_7_begin: {
                x: 45,
                y: 251
            },
            line_7_cell_0: {
                x: 67,
                y: 251
            },
            line_7_cell_1: {
                x: 249,
                y: 251
            },
            line_7_cell_2: {
                x: 431,
                y: 291
            },
            line_7_cell_3: {
                x: 613,
                y: 453
            },
            line_7_cell_4: {
                x: 795,
                y: 473
            },
            line_7_end: {
                x: 956,
                y: 473
            },
            line_7_gap_0: {
                x: 228,
                y: 251
            },
            line_7_gap_1: {
                x: 410,
                y: 272
            },
            line_7_gap_2: {
                x: 589,
                y: 435
            },
            line_7_gap_3: {
                x: 774,
                y: 473
            }
        },
        trajectory: [
            0,
            0,
            1,
            2,
            2
        ]
    },
    {
        chunks: {
            line_8_begin: {
                x: 45,
                y: 472
            },
            line_8_cell_0: {
                x: 67,
                y: 472
            },
            line_8_cell_1: {
                x: 249,
                y: 450
            },
            line_8_cell_2: {
                x: 431,
                y: 287
            },
            line_8_cell_3: {
                x: 613,
                y: 251
            },
            line_8_cell_4: {
                x: 795,
                y: 251
            },
            line_8_end: {
                x: 956,
                y: 251
            },
            line_8_gap_0: {
                x: 228,
                y: 472
            },
            line_8_gap_1: {
                x: 410,
                y: 432
            },
            line_8_gap_2: {
                x: 592,
                y: 268
            },
            line_8_gap_3: {
                x: 774,
                y: 251
            }
        },
        trajectory: [
            2,
            2,
            1,
            0,
            0
        ]
    },
    {
        chunks: {
            line_9_begin: {
                x: 45,
                y: 472
            },
            line_9_cell_0: {
                x: 67,
                y: 472
            },
            line_9_cell_1: {
                x: 249,
                y: 450
            },
            line_9_cell_2: {
                x: 431,
                y: 287
            },
            line_9_cell_3: {
                x: 613,
                y: 251
            },
            line_9_cell_4: {
                x: 795,
                y: 251
            },
            line_9_end: {
                x: 956,
                y: 251
            },
            line_9_gap_0: {
                x: 228,
                y: 472
            },
            line_9_gap_1: {
                x: 410,
                y: 432
            },
            line_9_gap_2: {
                x: 592,
                y: 268
            },
            line_9_gap_3: {
                x: 774,
                y: 251
            }
        },
        trajectory: [
            2,
            2,
            1,
            0,
            0
        ]
    }
]
};



//////////////////
// WEBPACK FOOTER
// ./cfg/lines-config.js
// module id = 21
// module chunks = 0